import { useQuery } from '@tanstack/react-query';

import type { PostalCodesApi } from '@izimi/api';

const STALE_30_MINUTES = 1800000;

const createPostalCodesModule = ({ postalCodesApi }: { postalCodesApi: PostalCodesApi }) => {
  const usePostalCodes = (postalCodeOrName: string | undefined, enabled = true) => {
    const { data, isLoading, error, isSuccess } = useQuery({
      queryKey: ['postalCodes', { postalCodeOrName }],
      queryFn: () => postalCodesApi.getPostalCodes({ postalCodeOrName }),
      staleTime: STALE_30_MINUTES,
      enabled,
    });

    return {
      postalCodes: data,
      error,
      isLoading,
      isSuccess,
    };
  };

  return {
    usePostalCodes,
  };
};

export default createPostalCodesModule;
